import { useState, useEffect } from 'react';
import { AiOutlineShoppingCart, AiOutlineHeart, AiOutlineEye } from 'react-icons/ai';
import { FaListUl, FaGripHorizontal } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import { GetWishListItems, RemoveItemFromWishList } from '../Data';
import { toast } from 'react-toastify';
import ProductModal from '../Common/ProductModal';
import { Global } from '../Variables/Global';
import Pagination from '../Pagination/Pagination';
import Cookies from 'js-cookie';

const WishListAR = () => {
    const [showList, setShowList] = useState("grid");
    const [showModal, setShowModal] = useState(false);
    const [WishListItems, setWishListItems] = useState([]);
    const [productDetails, setProductDetails] = useState();
    const [WishListCount, setWishListCount] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isLogged, setIsLogged] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();

    let LIMIT = 9;
    const token = Cookies.get("CustomerToken");
    const GetWishListItemsForShop = () => {
        var groupId;
        if (Cookies.get("WishList") !== undefined) {
            groupId = 4
        } else {
            groupId = 3
        }
        const getItem = (Cookies.get('WishList') !== undefined);
        if (getItem) {
            var WishlistId = Cookies.get("WishList");
            GetWishListItems(WishlistId, groupId, token).then((Result) => {
                setWishListItems(Result.WishlistItems);
                setWishListCount(Result.Count);
            });
        }
    }

    const HandleRemoveFromWishList = async (ProductId) => {
        const getItem = (Cookies.get('WishList') !== undefined);
        if (getItem) {
            var WishlistId = Cookies.get("WishList");
            RemoveItemFromWishList(ProductId, WishlistId, token).then((response) => {
                if (response.ok) {
                    GetWishListItemsForShop();
                    toast.success("Item Removed");
                    return response.json();
                } else {
                    return Response.text().then((text) => {
                        throw new Error(text);
                    });
                }
            }).catch((error) => {
                toast.error("Could Not Delete");
            })
        }
    }

    useEffect(() => {
        if (Cookies.get("CustomerToken") === undefined) {
            navigate("/AR/Authentication")
        }
        if (Cookies.get("CustomerToken") === undefined) {
            setIsLogged(false);
        } else {
            setIsLogged(true);
        }
        GetWishListItemsForShop();
    }, []);

    return (
        <>
            <div className="breadcrumb-area mb-5 ">
                <div className="container ">
                    <div className="row ">
                        <div className="col ">
                            <div className="breadcrumb-container  d-flex flex-row-reverse   ">
                                <div className="breadcrumbArabic HomeShop ">
                                    <ul>
                                        <li className="active">تواصل معنا</li>
                                        <li><a style={{ direction: 'rtl' }} href="index.html"><i className="fa fa-home"></i>
                                            المنزل</a></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="shop-page-container mb-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 mb-sm-35 mb-xs-35">
                            <div className="shop-header mb-3 directionRtl">
                                <div className="row">
                                    <div className="col-lg-4 col-md-4 col-sm-12 d-flex align-items-center">
                                        <div className="view-mode-icons mb-xs-10 directionLtr">
                                            <a className={showList.includes("grid") ? "active" : ""} data-target="grid" onClick={() => setShowList('grid')}><FaGripHorizontal /></a>
                                            <a className={showList.includes("list") ? "active" : ""} data-target="list" onClick={() => setShowList('list')}><FaListUl /></a>
                                        </div>
                                    </div>
                                    <div className="col-lg-8 col-md-8 col-sm-12 d-flex flex-column flex-sm-row justify-content-between align-items-left align-items-sm-center">
                                        <div className="sort-by-dropdown d-flex align-items-center mb-xs-10">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={"shop-product-wrap row no-gutters mb-35 " + showList} >
                                {
                                    WishListItems.length > 0 ? (
                                        WishListItems.map((product, index) => {
                                            return (
                                                <div key={index} className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                                                    <div className="gf-product shop-grid-view-product">
                                                        <div className="image">
                                                            <a href="single-product.html">
                                                                <img width="350" height="350" src={Global.PHOTO_URL + product.Image} className="img-fluid" alt="" />
                                                            </a>
                                                            <div className="product-hover-icons">
                                                                <a data-tooltip="Add to cart">
                                                                    <span className="icon_cart_alt"></span>
                                                                    <AiOutlineShoppingCart className='mb-1' color='white' />
                                                                </a>
                                                                <a data-tooltip="إزالة من المفضلة" onClick={() => HandleRemoveFromWishList(product.ProductId)}>
                                                                    <span className="icon_heart_alt"></span>
                                                                    <AiOutlineHeart className='mb-1' color='white' />
                                                                </a>
                                                            </div>
                                                        </div>
                                                        <div className="product-content">
                                                            <h3 className="product-title"><a className='RemUnderline' href="single-product.html" dangerouslySetInnerHTML={{ __html: product.ProductNameAR }}></a></h3>
                                                            <div className="price-box">
                                                                {
                                                                    product.SalePrice === 0 ? (
                                                                        <>
                                                                            <span className="discounted-price RemUnderline">AED{product.RegularPrice}</span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span className="discounted-price RemUnderline">AED{product.SalePrice}</span>
                                                                            <span className="main-price RemUnderline">AED{product.RegularPrice}</span>
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="gf-product shop-list-view-product">
                                                        <div className="image">
                                                            <a href="single-product.html">
                                                                <img width="350" height="350" src={Global.PHOTO_URL + product.Image} className="img-fluid" alt="" />
                                                            </a>
                                                            <div className="product-hover-icons">
                                                            </div>
                                                        </div>
                                                        <div className="product-content">
                                                            <h3 className="product-title"><a className='RemUnderline' href="single-product.html">{product.ProductNameAR} </a></h3>
                                                            <div className="price-box mb-2">
                                                                {
                                                                    product.SalePrice === 0 ? (
                                                                        <>
                                                                            <span className="discounted-price RemUnderline">AED{product.RegularPrice}</span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <span className="discounted-price RemUnderline">AED{product.SalePrice}</span>
                                                                            <span className="main-price RemUnderline">AED{product.RegularPrice}</span>
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                            <div className="list-product-icons">
                                                                <a data-tooltip="اضف الى السلة">
                                                                    <span className="icon_cart_alt"></span>
                                                                    <AiOutlineShoppingCart className='mb-1' color='white' />
                                                                </a>
                                                                <a data-tooltip="Remove From wishlist" onClick={() => HandleRemoveFromWishList(product.ProductId)}>
                                                                    <span className="icon_heart_alt"></span>
                                                                    <AiOutlineHeart className='mb-1' color='white' />
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {
                                                        showModal && (
                                                            <ProductModal
                                                                productDetails={productDetails}
                                                                showModal={showModal}
                                                                setShowModal={setShowModal}
                                                            />
                                                        )
                                                    }
                                                </div>
                                            );
                                        })
                                    ) : (
                                        <h1 className='mt-5' style={{ direction: 'rtl' }}>اذهب إلى <a href='/AR/shop' style={{ color: "#115938" }}>المتجر</a> لبدء إضافة منتجات إلى المفضلة</h1>
                                    )
                                }

                                {
                                    WishListItems.length > 0 && (
                                        <Pagination
                                            currentPage={currentPage}
                                            totalCount={WishListCount}
                                            pageSize={LIMIT}
                                            onPageChange={page => setCurrentPage(page)}
                                        />
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default WishListAR